import React from "react";
import PropTypes from "prop-types";
import ChatMemberList from "./chat-member-list";
import ChatRoomSettings from "./chat-room-settings";
import ChatRoom from "./chat-room";
import { useChatRoom } from "../contexts/chat-room-context";
import { routes } from "../contexts/chat-navigation-context";
import { getPoolIdFromRoomName, isDM, getETUserIDFromChatKitUser } from "../utils/utils";
import { useChatCurrentUser } from "../contexts/chat-current-user-context";
import { useChatDependencyContext } from "../contexts/chat-dependency-context";
import { useCachedPoolById } from "../contexts/cached-pools-context";
import { useETCachedUserById } from "../contexts/et-user-context";

const ChatRoomRoutes = ({ roomId, url = "room" }) => {
  const { oid } = useChatDependencyContext();
  const { currentChatUser } = useChatCurrentUser();
  const { currentRoom, ...rest } = useChatRoom({
    roomId,
  });
  // isolate logic so not parsing same data in multiple files
  const pool_id = getPoolIdFromRoomName(oid, currentRoom.name);

  const { pool } = useCachedPoolById(pool_id);
  const is_dm = isDM(currentRoom.name);
  const other_chatkit_user_in_dm =
    (currentRoom.users && currentRoom.users.find(user => user.id !== "super" && user.id !== currentChatUser.id)) || {};

  const et_user_id = getETUserIDFromChatKitUser(oid, other_chatkit_user_in_dm.id);
  const { user } = useETCachedUserById(et_user_id);

  const room_name = is_dm ? user.name : pool.name;
  if (url === routes.room_settings) {
    return <ChatRoomSettings roomId={roomId} roomName={room_name} currentRoom={currentRoom} />;
  }
  if (url === routes.member_list) {
    return <ChatMemberList roomId={roomId} roomName={room_name} currentRoom={currentRoom} />;
  }
  return <ChatRoom roomId={roomId} roomName={room_name} currentRoom={currentRoom} {...rest} />;
};

ChatRoomRoutes.propTypes = {
  roomId: PropTypes.any,
  url: PropTypes.string.isRequired,
};

export default ChatRoomRoutes;
